/* Store Locator (Utility Hub): the map, search, distances and the open/closed state. Reads the JSON the data snippet writes. */
(function () {
  'use strict';
  var DAYS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
  var NAMES = { sun: 'Sunday', mon: 'Monday', tue: 'Tuesday', wed: 'Wednesday', thu: 'Thursday', fri: 'Friday', sat: 'Saturday' };

  function clock(hhmm) { var p = hhmm.split(':'); var h = +p[0]; return (((h + 11) % 12) + 1) + ':' + p[1] + ' ' + (h >= 12 ? 'PM' : 'AM'); }
  function localNow(tz) {
    try {
      var parts = new Intl.DateTimeFormat('en-US', { timeZone: tz || 'America/New_York', weekday: 'short', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false }).formatToParts(new Date());
      var o = {}; parts.forEach(function (x) { o[x.type] = x.value; });
      return { day: o.weekday.toLowerCase().slice(0, 3), iso: o.year + '-' + o.month + '-' + o.day, mins: (+o.hour % 24) * 60 + (+o.minute), dow: DAYS.indexOf(o.weekday.toLowerCase().slice(0, 3)) };
    } catch (e) { var d = new Date(); return { day: DAYS[d.getDay()], iso: d.toISOString().slice(0, 10), mins: d.getHours() * 60 + d.getMinutes(), dow: d.getDay() }; }
  }
  function mins(hhmm) { var p = hhmm.split(':'); return (+p[0]) * 60 + (+p[1]); }
  function hoursOn(loc, iso, day) {
    var s = (loc.special || []).filter(function (x) { return x.date === iso; })[0];
    return s || (loc.hours && loc.hours[day]) || { status: 'closed' };
  }
  function addDays(iso, n) { var d = new Date(iso + 'T12:00:00Z'); d.setUTCDate(d.getUTCDate() + n); return d.toISOString().slice(0, 10); }
  function openState(loc) {
    var now = localNow(loc.tz), h = hoursOn(loc, now.iso, now.day);
    if (h.status === '24h') return { open: true, text: 'Open 24 hours' };
    if (h.status === 'open') {
      if (now.mins >= mins(h.open) && now.mins < mins(h.close)) return { open: true, text: 'Open now · closes ' + clock(h.close) };
      if (now.mins < mins(h.open)) return { open: false, text: 'Closed · opens today ' + clock(h.open) };
    }
    for (var i = 1; i <= 14; i++) {
      var iso = addDays(now.iso, i), day = DAYS[(now.dow + i) % 7], n = hoursOn(loc, iso, day);
      if (n.status === 'open') return { open: false, text: 'Closed · opens ' + (i === 1 ? 'tomorrow' : NAMES[day]) + ' ' + clock(n.open) };
      if (n.status === '24h') return { open: false, text: 'Closed · opens ' + NAMES[day] };
    }
    return { open: false, text: 'Closed' };
  }
  function miles(a, b) {
    var R = 3958.8, toR = Math.PI / 180, dLat = (b.lat - a.lat) * toR, dLng = (b.lng - a.lng) * toR;
    var x = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(a.lat * toR) * Math.cos(b.lat * toR) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return 2 * R * Math.atan2(Math.sqrt(x), Math.sqrt(1 - x));
  }
  function esc(s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function readData(root) {
    var el = root.querySelector('[data-uh-locator-data]');
    if (!el) return [];
    try { return JSON.parse(el.textContent).map(function (l) { l.lat = +l.lat; l.lng = +l.lng; return l; }); } catch (e) { return []; }
  }

  function markOpenState(root, data) {
    var byHandle = {};
    data.forEach(function (l) { byHandle[l.handle] = l; });
    root.querySelectorAll('[data-uh-card]').forEach(function (card) {
      var loc = byHandle[card.getAttribute('data-uh-card')], el = card.querySelector('[data-uh-open]');
      if (!loc || !el) return;
      var s = openState(loc); el.textContent = s.text; el.classList.add(s.open ? 'is-open' : 'is-closed');
    });
    var line = root.querySelector('[data-uh-open-now]');
    if (line && root.hasAttribute('data-uh-store')) {
      var mine = byHandle[root.getAttribute('data-handle')];
      if (mine) { var st = openState(mine); line.textContent = st.text; line.classList.add(st.open ? 'is-open' : 'is-closed'); }
    }
  }

  function initLocator(root) {
    var data = readData(root), token = root.getAttribute('data-token'), color = root.getAttribute('data-marker') || '#005862', pinUrl = root.getAttribute('data-marker-url') || '', zoom = +(root.getAttribute('data-zoom') || 9);
    var list = root.querySelector('[data-uh-list]'), count = root.querySelector('[data-uh-count]'), status = root.querySelector('[data-uh-status]');
    var mapEl = root.querySelector('[data-uh-map]'), form = root.querySelector('[data-uh-search]'), locate = root.querySelector('[data-uh-locate]'), filters = root.querySelector('[data-uh-filters]');
    var map = null, markers = {}, origin = null, active = [];
    markOpenState(root, data);
    var cards = {};
    root.querySelectorAll('[data-uh-card]').forEach(function (c) { cards[c.getAttribute('data-uh-card')] = c; });

    function visible() {
      var tags = filters ? Array.prototype.map.call(filters.querySelectorAll('input:checked'), function (i) { return i.value; }) : [];
      return data.filter(function (l) { return !tags.length || tags.every(function (t) { return (l.tags || []).indexOf(t) >= 0; }); });
    }
    function render() {
      var rows = visible();
      if (origin) rows.forEach(function (l) { l.dist = isFinite(l.lat) ? miles(origin, l) : 1e9; });
      rows.sort(origin ? function (a, b) { return a.dist - b.dist; } : function (a, b) { return (a.region || '').localeCompare(b.region || '') || (b.priority || 0) - (a.priority || 0) || a.name.localeCompare(b.name); });
      var shown = {};
      rows.forEach(function (l, i) {
        var c = cards[l.handle]; if (!c) return; shown[l.handle] = true; c.hidden = false; list && list.appendChild(c);
        var d = c.querySelector('[data-uh-distance]'); if (d) d.textContent = origin && l.dist < 1e8 ? l.dist.toFixed(1) + ' mi' : '';
        if (markers[l.handle]) markers[l.handle].getElement().style.display = '';
      });
      Object.keys(cards).forEach(function (h) { if (!shown[h]) { cards[h].hidden = true; if (markers[h]) markers[h].getElement().style.display = 'none'; } });
      if (count) count.textContent = rows.length + (rows.length === 1 ? ' store' : ' stores') + (origin ? ', nearest first' : '');
      active = rows;
    }
    function fit() {
      if (!map || !active.length) return;
      var b = new mapboxgl.LngLatBounds();
      active.forEach(function (l) { if (isFinite(l.lat) && isFinite(l.lng)) b.extend([l.lng, l.lat]); });
      if (!b.isEmpty()) map.fitBounds(b, { padding: 40, maxZoom: 11, duration: 600 });
    }
    function buildMap() {
      if (!mapEl || !window.mapboxgl || !token) { if (mapEl && !token) mapEl.textContent = 'Map unavailable: no Mapbox token.'; return; }
      mapboxgl.accessToken = token;
      map = new mapboxgl.Map({ container: mapEl, style: 'mapbox://styles/mapbox/light-v11', center: [-95.7, 37.1], zoom: 3.4 });
      map.addControl(new mapboxgl.NavigationControl({ showCompass: false }), 'top-right');
      data.forEach(function (l) {
        if (!isFinite(l.lat) || !isFinite(l.lng)) return;
        var popup = new mapboxgl.Popup({ offset: 24, closeButton: false }).setHTML('<div class="uh-loc-popup"><b>' + esc(l.name) + '</b>' + esc(l.address1) + '<br>' + esc(l.city) + ', ' + esc(l.region) + ' ' + esc(l.zip) + '<br><a href="' + esc(l.url) + '">Store page</a></div>');
        var m;
        if (pinUrl) { var el = document.createElement('div'); el.className = 'uh-loc-pinwrap'; el.innerHTML = '<span class="uh-loc-pin"><img src="' + esc(pinUrl) + '" alt=""></span>'; m = new mapboxgl.Marker({ element: el, anchor: 'center' }); }
        else m = new mapboxgl.Marker({ color: color });
        m.setLngLat([l.lng, l.lat]).setPopup(popup).addTo(map);
        m.getElement().addEventListener('click', function () { highlight(l.handle); });
        markers[l.handle] = m;
      });
      map.on('load', fit);
    }
    function highlight(handle) {
      Object.keys(cards).forEach(function (h) { cards[h].classList.toggle('is-active', h === handle); });
      var c = cards[handle]; if (c && list) c.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
    Object.keys(cards).forEach(function (h) {
      cards[h].addEventListener('mouseenter', function () { if (markers[h]) { var e = markers[h].getElement(); e.style.zIndex = 5; e.classList.add('is-hot'); } });
      cards[h].addEventListener('mouseleave', function () { if (markers[h]) { var e = markers[h].getElement(); e.style.zIndex = ''; e.classList.remove('is-hot'); } });
    });
    function setOrigin(lat, lng, label, quiet) {
      origin = { lat: lat, lng: lng };
      render();
      if (status) status.textContent = label ? 'Stores nearest ' + label : 'Stores nearest you';
      if (map && !quiet) map.flyTo({ center: [lng, lat], zoom: zoom, duration: 800 });
    }
    // Same starting point as the homepage strip: a location this visitor shared before (localStorage), else a rough
    // guess from the time zone, refined silently when the browser already allows geolocation. Never prompts on load.
    var GEO_KEY = 'sp_local_geo', GEO_MAX_AGE = 30 * 24 * 3600 * 1000;
    var TZ_GUESS = { 'America/Los_Angeles': [37.70, -122.10], 'America/Vancouver': [47.75, -122.15], 'America/Denver': [39.70, -105.00], 'America/Boise': [40.50, -111.90], 'America/Phoenix': [33.60, -112.20], 'America/Chicago': [32.90, -97.00], 'America/Indiana/Indianapolis': [38.30, -85.75], 'America/Detroit': [41.17, -81.86], 'America/New_York': [40.70, -74.10], 'America/Toronto': [40.70, -74.10] };
    function savedGeo() { try { var v = JSON.parse(localStorage.getItem(GEO_KEY) || 'null'); return v && Date.now() - v.t < GEO_MAX_AGE ? v : null; } catch (e) { return null; } }
    function saveGeo(lat, lng) { try { localStorage.setItem(GEO_KEY, JSON.stringify({ lat: +lat.toFixed(2), lng: +lng.toFixed(2), t: Date.now() })); } catch (e) {} }
    function tzGuess() { var tz = ''; try { tz = Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch (e) {} if (TZ_GUESS[tz]) return TZ_GUESS[tz]; if (/^America\/(Kentucky|Indiana)/.test(tz)) return [38.30, -85.75]; return TZ_GUESS['America/New_York']; }
    function startNearest() {
      var saved = savedGeo();
      if (saved) { setOrigin(saved.lat, saved.lng, '', true); return; }
      var g = tzGuess(); origin = { lat: g[0], lng: g[1] }; render(); if (status) status.textContent = 'Stores nearest your area · search or use your location for exact distances';
      if (navigator.permissions && navigator.geolocation) navigator.permissions.query({ name: 'geolocation' }).then(function (p) { if (p.state === 'granted') navigator.geolocation.getCurrentPosition(function (pos) { saveGeo(pos.coords.latitude, pos.coords.longitude); setOrigin(pos.coords.latitude, pos.coords.longitude, '', true); }, function () {}, { maximumAge: 3600000, timeout: 10000 }); }).catch(function () {});
    }
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      var q = form.querySelector('input[name=uh_q]').value.trim();
      if (!q || !token) return;
      if (status) status.textContent = 'Looking up ' + q + '…';
      fetch('https://api.mapbox.com/search/geocode/v6/forward?q=' + encodeURIComponent(q) + '&country=us&limit=1&access_token=' + encodeURIComponent(token))
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var f = j.features && j.features[0];
          if (!f) { if (status) status.textContent = 'No place found for "' + q + '".'; return; }
          setOrigin(f.geometry.coordinates[1], f.geometry.coordinates[0], (f.properties && f.properties.name) || q);
        }).catch(function () { if (status) status.textContent = 'The lookup did not answer. Try again.'; });
    });
    if (locate) locate.addEventListener('click', function () {
      if (!navigator.geolocation) { if (status) status.textContent = 'Your browser does not share location.'; return; }
      if (status) status.textContent = 'Finding you…';
      navigator.geolocation.getCurrentPosition(function (p) { saveGeo(p.coords.latitude, p.coords.longitude); setOrigin(p.coords.latitude, p.coords.longitude, ''); }, function () { if (status) status.textContent = 'Location was not shared. Search by city or ZIP instead.'; }, { timeout: 10000, maximumAge: 600000 });
    });
    if (filters) filters.addEventListener('change', function () { render(); fit(); });
    render();
    if (list && count) startNearest();          // the landing page; a state page keeps its own order
    if (window.mapboxgl) buildMap(); else window.addEventListener('load', buildMap);
  }

  function boot() {
    document.querySelectorAll('[data-uh-locator]').forEach(initLocator);
    document.querySelectorAll('[data-uh-store]').forEach(function (root) { markOpenState(root, readData(root)); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
